/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WbsPlanningDto interface.
 */
export function instanceOfWbsPlanningDto(value) {
    return true;
}
export function WbsPlanningDtoFromJSON(json) {
    return WbsPlanningDtoFromJSONTyped(json, false);
}
export function WbsPlanningDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'mese': json['mese'] == null ? undefined : json['mese'],
        'anno': json['anno'] == null ? undefined : json['anno'],
        'corrispettivo': json['corrispettivo'] == null ? undefined : json['corrispettivo'],
        'enable': json['enable'] == null ? undefined : json['enable'],
    };
}
export function WbsPlanningDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'mese': value['mese'],
        'anno': value['anno'],
        'corrispettivo': value['corrispettivo'],
        'enable': value['enable'],
    };
}
